import { knopfRennt } from '../../game/joystick';
import { istTouchGeraet } from '../../lib/eingabeart';
import { Button } from '../../components/Button';
import { useInteractionStore } from '../../stores/interactionStore';
import { useMediaStore } from '../../stores/mediaStore';
import { useTouchSteuerungStore } from '../../stores/touchSteuerungStore';
import { useViewStore } from '../../stores/viewStore';
import { useOffice } from './OfficeContext';
import './touchSteuerung.css';

const TOUCH = istTouchGeraet();

const SITZ_TEXT = { hinsetzen: 'Hinsetzen', aufstehen: 'Aufstehen' } as const;

/**
 * Anzeige der Touch-Steuerung: der Joystick-Ring (aus dem Store, den der
 * Controller fuellt) und die Knoepfe fuer Benutzen und Anklingeln. Die
 * Flaeche selbst laesst alle Finger durch — sie gehoeren dem Canvas.
 */
export function TouchSteuerung() {
  const { runtime } = useOffice();
  const mode = useViewStore((s) => s.mode);
  const modalOffen = useInteractionStore((s) => s.openObject !== null);
  const stick = useTouchSteuerungStore((s) => s.stick);
  const sitzAktion = useInteractionStore((s) => s.sitzAktion);
  const objekt = useInteractionStore((s) => s.nearbyObject);
  const kannKlingeln = useMediaStore((s) =>
    Object.values(s.peers).some((p) => !p.mediaActive && p.ring !== 'outgoing'),
  );

  if (!TOUCH || mode !== '3d' || modalOffen) return null;

  const benutzenText = sitzAktion ? SITZ_TEXT[sitzAktion] : objekt ? 'Benutzen' : null;

  return (
    <div className="touch-steuerung" aria-hidden={false}>
      {stick ? (
        <div
          className={`touch-steuerung__stick${
            knopfRennt({ x: stick.basisX, y: stick.basisY }, { x: stick.knopfX, y: stick.knopfY })
              ? ' touch-steuerung__stick--rennt'
              : ''
          }`}
          style={{ transform: `translate(${stick.basisX}px, ${stick.basisY}px)` }}
        >
          <div
            className="touch-steuerung__knopf"
            style={{ transform: `translate(${stick.knopfX - stick.basisX}px, ${stick.knopfY - stick.basisY}px)` }}
          />
        </div>
      ) : (
        <div className="touch-steuerung__stick touch-steuerung__stick--ruhe" aria-hidden="true">
          <div className="touch-steuerung__knopf" />
        </div>
      )}
      <div className="touch-steuerung__aktionen">
        {kannKlingeln && (
          <Button variant="ghost" onClick={() => runtime.anklingeln()}>
            Anklingeln
          </Button>
        )}
        {benutzenText && (
          <Button variant="primary" onClick={() => runtime.benutzen()}>
            {benutzenText}
          </Button>
        )}
      </div>
    </div>
  );
}
